import { Box, Divider, Heading, HStack, VStack } from "@chakra-ui/react";
import DocumentListItem, { DocumentListItemProps } from "../DocumentListItem";


export interface DocumentListProps {
    listTitle?: string,
    documents: DocumentListItemProps[]
};

const DocumentList = (props: DocumentListProps) => {
    return (
        <Box paddingBottom='20px'>
            { 
                props.listTitle !== undefined && 
                    <Heading size='md' paddingBottom='10px'>
                        { props.listTitle }
                    </Heading> 
            }
            <Box 
                maxW='smidddd' 
                borderWidth='1px' 
                borderRadius='lg' 
                overflow='hidden' 
                padding='10px'
            >
                {
                    props.documents.map((documentProps) =>
                        <><DocumentListItem { ...documentProps } /><Divider /></>
                )}
            </Box>
        </Box>
    );
};

export default DocumentList;